<!-- banner -->
<style scoped>
.banner {
  min-height: 262.5px;
  width: 100%;
}
.swiperItem {
    position: relative;
    width: 100%;
    height: 100%;
}
.banner img {
  width: 100%;
  height: 100%;
}
.banner >>> .swiper-pagination-bullet {
    width: 36px;
    height: 7px;
    background-color: #ffffff;
    border-radius: 0;
    opacity: .5;
}
.banner >>> .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1;
}
</style>
<template>
<div>   
    <div style="height:80px">
      <hearder></hearder>
    </div>

    <div class="banner">
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide>
                <div class="swiperItem">
                    <img src="@/assets/images/banner1.jpg">
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="swiperItem">
                    <img src="@/assets/images/banner2_2.jpg">
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="swiperItem">
                    <img src="@/assets/images/banner3.jpg">
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="swiperItem">
                    <img src="@/assets/images/banner4.jpg">
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="swiperItem">
                    <img src="@/assets/images/banner5.jpg">
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
    <ctServich></ctServich>
    <backToTop></backToTop>
    <videoBox></videoBox>
</div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import hearder from '@/components/hearder'
import ctServich from "@/components/ctServich.vue"
import backToTop from "@/components/backToTop.vue"
import videoBox from "@/components/videoBox.vue"
export default {
    name: 'banner',
    components: {
        Swiper,
        SwiperSlide,
        hearder,
        backToTop,
        videoBox,
        ctServich
    },
    directives: {
        swiper: directive
    },
    data () {
        return {
            swiperOptions: {
                initialSlide: 0,
                loop : true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true
                },
                // preloadImages: true,
                // updateOnImagesReady : true,
                // observer: true,
                // observeParents: true,
                // observeSlideChildren:true
            }
        }
    },
    methods: {
        videoPlay() {
            this.$refs.mySwiper.destroySwiper();
            this.swiperOptions.autoplay = false;
            this.swiperOptions.initialSlide = 1;
            this.$refs.mySwiper.initSwiper();
        },
        videoPause() {
            let activeIndex = this.$refs.mySwiper.$swiper.activeIndex;
            this.$refs.mySwiper.destroySwiper();
            this.swiperOptions.initialSlide = (activeIndex-=1);
            this.swiperOptions.autoplay = {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false
            }
            this.$refs.mySwiper.initSwiper();
        },
    },
    mounted() {
        const videoDOM = document.getElementById('videoDOM');
        videoDOM.addEventListener('play', this.videoPlay,true);
        videoDOM.addEventListener('pause',this.videoPause,true);
    },
    destroyed() {
        const videoDOM = document.getElementById('videoDOM');
        videoDOM.removeEventListener('play', this.videoPlay);
        videoDOM.removeEventListener('pause',this.videoPause);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/banner.vue